import translationEN from '../../assets/locales/en/translation.json';
import translationFR from "../../assets/locales/fr/translation.json";
import translationPL from "../../assets/locales/pl/translation.json";

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { enqueueSnackbar } from 'notistack';
import {State} from '../../components/grid/BasicGridState'

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import '../../components/grid/styles.scss';
import '../../components/grid/slickgrid.scss';
import '../../layouts/gridlayout.css'
import i18next, { TFunction } from 'i18next';

import DataChangeService, { ChangeTypes } from "../../services/datachange/datachange.service";
import { ColorEditor } from '../../components/grid/CustomEditors/ColorEditor';

import {
   SlickgridReact, FieldType, Filters,
   GridOption,
  Column, Formatter, Formatters,
  Editors, EditCommand, 
  CompositeEditorModalType, OnCompositeEditorChangeEventArgs, CompositeEditorSelection,
  InputEditor,
  SlickGrid,
  OnAddNewRowEventArgs,
  EditorValidator,
  CurrentSorter,
  EmitterType,
} from 'slickgrid-react';

import { ExcelExportService } from '@slickgrid-universal/excel-export';
import { OdataOption, OdataServiceApi } from '@slickgrid-universal/odata';


import BaseGrid, {BasicGridProps} from '../../components/grid/BaseGridComponent';
import { TextOperators } from '../../components/grid/CustomFilters/TextFilter';
import { SlickCustomTooltip } from '@slickgrid-universal/custom-tooltip-plugin';
import authService from '../../services/auth/auth.service';
import { LookupCollection, LookupData } from '../../components/grid/GridUtils';

import { withTranslation } from 'react-i18next';
import { isEditable } from '@testing-library/user-event/dist/utils';
import BorderSpinner from '../../components/Layout/spinner';

const ContrastColor = require('contrast-color');


const location = window.location
  
const locationley = location.pathname.replace('/', '')
const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-search' 

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  pl: {
    translation: translationPL
  }
};


class DataChange extends BaseGrid {
  
    title = 'Historia zmian';
    subTitle = 'Przegląd historii zmian'
    lastApiCall : Date;

 constructor(public readonly props: BasicGridProps) {
    super(props);
    this.lastApiCall = new Date(0)
   
    
 }

setSearchFilter() {
  if (this.reactGrid && localStorage[this.search_key] && localStorage[this.search_key]!==''){
    this.reactGrid.filterService.updateFilters([])

  }else{
    if (this.reactGrid){
       this.reactGrid.filterService.clearFilters()
    }
  }
}

  
onStorage = () => {
  this.setSearchFilter()
};
onFocus = () => {
  window.addEventListener("storage", this.onStorage)
};
onBlur = () => {
  window.removeEventListener("storage", this.onStorage)
};
  
componentDidMount() {
    window.addEventListener("resize",((e: any) =>{
      setTimeout(() => { this.reactGrid.resizerService.resizeGrid(); }, 1000);
      
  }).bind(this));

  window.addEventListener("focus", this.onFocus);
  window.addEventListener("blur", this.onBlur);
  this.onFocus();

  this.defineGrid()

  //this.getusergrouplookup();
    i18next.init({
      lng: 'pl',
      debug: false,
      resources: resources
    }, (err, t) => {
      i18next.changeLanguage("pl");
      
    });
  
}


 defineGrid() {
    var presets = JSON.parse(localStorage[this.storage_key] || null);

    if (presets){
      var new_sorters = presets.sorters.map((element: CurrentSorter) => {
        element.columnId = (element.columnId as string).toLowerCase();
        return element;
      });
      presets.sorters = new_sorters;
    }
   
    var gridOptions =  this.getGridDefinition();
    gridOptions.presets = presets

    var columnDefinitions = this.getColumnDefinitions();

    this.setState((state: State) => ({
      ...state,
      gridOptions:gridOptions,
      columnDefinitions:columnDefinitions,
    
  }));
}

componentDidUpdate(PrevProps: any, prevState: State){
  if(this.state.alertErrorMsg !== prevState.alertErrorMsg){
      if (this.state.alertErrorMsg){
        //alert(this.state.alertErrorMsg)
      }
  }   
  
}


  getGridDefinition(): GridOption {    
      var tmp = super.getGridDefinition(this.state);
      tmp = {
        ...tmp,
        enableTranslate: true,
        i18n: i18next,
        //autoResize: {
        //  container: '#smaller-container',
         // rightPadding: 10
        //},
        editable:false,
        enableAddRow:false,
        enableExcelExport : true,
        excelExportOptions: {
          sanitizeDataExport: true
        },
        externalResources: [this.excelExportService, this.compositeEditorInstance, new SlickCustomTooltip()],
        
        presets: {},
        
        backendServiceApi: {
          ...tmp.backendServiceApi,
          onError: (error: Error) => {
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Błąd połączenia!"
              }));  
          },
          preProcess: () => {
            this.setState((state: State) => ({ ...state, errorStatus: '' }));
            this.displaySpinner(true);
          },
          process: (query) => {
            if (localStorage[this.search_key] && localStorage[this.search_key]!=''){
              query=query + "&$search=" + localStorage[this.search_key].replace('&', 'i') 
            }
            return this.getDataChangeApiCall(query)},
          postProcess: (response) => {
            if (new Date(response.metrics.startTime) > this.lastApiCall){
              this.lastApiCall = new Date(response.metrics.startTime)
              this.setState(
                (state: State) => ({ ...state, metrics: response.metrics }),
                () => this.postProcessCallback(response)
              );
            }
            this.displaySpinner(false);
          },
        } as OdataServiceApi
      }
    return tmp;
  }

  userFormatter = function (row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
		var s=""
    if ( dataContext.modifier_shortcut !=null){   
         s=  '<a class="slickRowLink" href="/users">' +
            '<span style="background-color:' + dataContext.modifier_color + '!important; color: ' + new ContrastColor(dataContext.modifier_color) + '" class="gavatar_m" >' + dataContext.modifier_shortcut +'</span>' + '</a>'
		}
    return s;
  };

  rownameFormatter = function (row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
		var s=""
    if ( dataContext.table_name =='contractors'){  
			s ="<a class='slickRowLink' href='/contractors/edit/" + dataContext.table_id + "' >" + dataContext.row_name + "</a>";   
		}else if ( dataContext.table_name =='contactpersons'){ 
		   s ="<a class='slickRowLink' href='/contacts/edit/" + dataContext.table_id + "' >" + dataContext.row_name + "</a>";   
		}else if ( dataContext.table_name =='notes'){  
			//s ="<a class='slickRowLink' href='" +  "<?= $this->Url->build(['controller'=>'contractors','action'=>'edit'])?>/" + dataContext.contractor_id + "' target=_blank>" + //dataContext.contractor_name + "</a>";   
			if ( dataContext.row_name !=null){
			s ="<a class='slickRowLink' href='/contractors/edit/'" + dataContext.note_contractor_id + "' >" + dataContext.row_name + "</a>";   
			}else{
				s ="";
			}
    }else if ( dataContext.table_name =='users'){  
      s =value;    
		}else{
			s =value;
		}
        return s;
    };


 /* getusergrouplookup(){
    return userService.getusergrouplookup().then(response => {
       let tmp : LookupData[] = [];
       if ((response.data) && (Array.isArray(response.data))){
          response.data.forEach((element) => tmp.push({value:element.name, label:element.name}));
       }   
       let tmp1 :LookupCollection = {name:'usergroup', data:tmp}
       this.setState((state: State) => ({
        ...state,
        lookupData : [tmp1]
      }),  () => this.defineGrid()
      );
    }
       
    ).catch(
      () => {
        let tmp : LookupData[] = [];
        this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
        }));
        return tmp;
      }
    )
  }
  */

  getColumnDefinitions(): Column[] {
    super.getColumnDefinitions()
    let tmp : Column[] = [];
    
    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
        {
          id: 'changedate', name: 'Data modyfikacji', field: 'changedate', sortable: true, filterable: true,
          type: FieldType.dateTimeIso,
          formatter:Formatters.dateTimeIso,
          filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
          hidden:false,
          minWidth:100
               
        },
        {
          id: 'changetype_name', name: 'Typ modyfikacji', field: 'changetype_name', sortable: true, filterable: true,
          type: FieldType.string,
          //formatter:this.taskTranslateFormatter,
          filter: { 
            collection: ChangeTypes,
            model: Filters.multipleSelect,
            searchTerms: [],
            queryField: "changetype_id"
          },        
          hidden:false,
          minWidth:100
               
        },
        {
          id: 'modifier_shortcut', name: 'Zmiana przez', field: 'modifier_shortcut', sortable: true, filterable: true,
          type: FieldType.string,
          cssClass: "column-centered",
          formatter:this.userFormatter,
          filter: {model: Filters.inputText,},           
          hidden:false,
          minWidth:50
               
        },
        {
          id: 'table_caption', name: 'Tabela', field: 'table_caption', sortable: true, filterable: true,
          type: FieldType.string,
          //formatter:this.taskTranslateFormatter,
          filter: {model: Filters.inputText,},           
          hidden:false,
          minWidth:100
               
        },
        {
          id: 'column_caption', name: 'Kolumna', field: 'column_caption', sortable: true, filterable: true,
          type: FieldType.string,
          //formatter:this.taskTranslateFormatter,
          filter: {model: Filters.inputText,},           
          hidden:false,
          minWidth:100
               
        },
        {
          id: 'row_name', name: 'Dotyczy', field: 'row_name', sortable: true, filterable: true,
          type: FieldType.string,
          formatter:this.rownameFormatter,
          filter: {model: Filters.inputText,},           
          hidden:false,
          minWidth:100
               
        },
        {
          id: 'description', name: 'Opis', field: 'description', sortable: true, filterable: true,
          type: FieldType.string,
          //formatter:this.taskTranslateFormatter,
          filter: {model: Filters.inputText,},           
          hidden:false,
          minWidth:100
               
        },
        
        
    );
    tmp = this.customizeHeaderMenu(tmp)
    return tmp
  }

  setPasswordFormatter(row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
    const tooltipTitle = 'Ustaw hasło';
    return `<div class="header-tooltip-title">${tooltipTitle}</div>
    <div class="tooltip-2cols-row"><div>Użytkownik:</div> <div>${dataContext.firstname} ${dataContext.surname}</div></div>`;
  }

  deleteUserFormatter(row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
    const tooltipTitle = 'Usuń';
    return `<div class="header-tooltip-title">${tooltipTitle}</div>
    <div class="tooltip-2cols-row"><div>Użytkownik:</div> <div>${dataContext.firstname} ${dataContext.surname}</div></div>`;
  }

  getDataChangeApiCall(query: string) {
    return DataChangeService.getdatachanges(query)
  }
  
  sortCollectionDescending(collection: any[]) {
    return collection.sort((item1, item2) => item1.value - item2.value);
  }


  checkItemIsEditable(dataContext: any, columnDef: Column, grid: SlickGrid) {
    return false;
  }


  handleOnCompositeEditorChange(_e: Event, args: OnCompositeEditorChangeEventArgs) {
    
  }

  handleOnBeforeEditCell(e: Event, args: any) {
    const { column, item, grid } = args;

    return false;
  }

  resizeContent($event:any){
   
  }

  render() {
    if (this.state.alertWarning) {
      enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: ''
      }));
    }
    if (this.state.alertError) {
      enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertError: ''
      }));
    }

    if (this.state.alertInfo) {
      enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertInfo: ''
      }));
    }

    return !this.state.gridOptions ? '' : (
       <>
          <div className="gridMenu">
            <div className='gridLeftSubMenu'> 
              
            </div>
            
            
            <div className='gridCenterSubMenu'>
    
              
            </div><div className='gridRightSubMenu'>
                <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                  onClick={() => this.setFactorySettings()}>
                  Ustawienia domyślne
                </button>

              </div>
          </div>
          <div id="smaller-container" onResize={this.resizeContent} style={{ width: '100%' }}>
          {this.state.status.text =='loading' ? <BorderSpinner/> : ''}

          <SlickgridReact gridId="datachange-grid"
            columnDefinitions={this.state.columnDefinitions}
            gridOptions={this.state.gridOptions}
            dataset={this.state.dataset}
            paginationOptions={this.state.paginationOptions}
            onReactGridCreated={$event => this.reactGridReady($event.detail)}
            onGridStateChanged={$event => this.gridStateChanged($event.detail)}
            onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
          
          />
          </div>
      </>
    );
  }
}

export default withTranslation()(DataChange);